export const resources = {
  resourcesFolderInfoText: 'Bestand(en)',
  resourcesItemInfoLastUpdText: 'Bijgewerkt',
  resourcesItemInfoUploadedText: 'Geüpload',
  resourcesSearchInputText: 'Zoeken',
  resourcesUserActionSheetOptionTitle: 'Kopieer link',
  resourcesActionCopiedAlertText: 'Link gekopieerd!',
  resourcesOwnersCurtainEditOptionText: 'Bewerk titel',
  resourcesOwnersCurtainDeleteOptionText: 'Verwijderen',
  resourcesOwnerCurtainHideOptionText: 'Verbergen (Inactief)',
  resourcesEditPopupTitle: 'Bewerk titel',
  resourcesEditPopupResetButtonTitle: 'Resetten',
  resourcesEditPopupApplyButtonTitle: 'Toepassen',
  resourcesItemEditedAlertText: 'Item is succesvol bijgewerkt!',
  resourcesHidePopupTitle: 'Verbergen',
  resourcesHidePopupText: 'Deze item verbergen?',
  resourcesHidePopupCancelButtonTitle: 'Annuleren',
  resourcesHidePopupConfirmButtonTitle: 'Bevestigen',
  resourcesDeletePopupTitle: 'Verwijderen',
  resourcesDeletePopupText: 'Deze item verwijderen?',
  resourcesDeletePopupCancelButtonTitle: 'Annuleren',
  resourcesDeletePopupConfirmButtonTitle: 'Bevestigen',
  resourcesItemDeletedAlertText: 'Item is succesvol verwijderd!',
  resourceDetailsLinkText: 'Dit is een externe URL en zal worden geopend in een nieuw venster. Openen?',
  resourceDetailsLinkOpenButtonTitle: 'Openen',
  resourceDetailsLinkOpenAgainButtonTitle: 'Opnieuw openen',
  resourceDetailsLinkCopyURLButtonTitle: 'Kopieer doel-URL',
  resourceDetailsLinkCopiedURLAlertText: 'URL gekopieerd!',
  resurceDetailsLinkCurtainOptionCopyText: 'Kopieer link',
  resourceDetailsFileInfoLastUpdText: 'Bijgewerkt',
  resourceDetailsFileInfoUploadText: 'Geüpload',
  resourceDetailsFileSaveButtonTitle: 'Openen',
  resourceDetailsFileCopyButtonTitle: 'Kopieer link',
  resourcesOwnersCurtainCopyOptionText: 'Kopieer link',
  resourceDetailsFileLoadingText: 'Downloaden...',
  resourceDetailsImageCurtainCopyOptionText: 'Kopieer link',
  resourceDetailsImageCurtainDownloadOptionText: 'Downloaden',
  resourceFolder: 'Map',
  resourceAdded: 'Toegevoegd'
}
